"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MultiSelectEditor;

var _react = _interopRequireWildcard(require("react"));

var _MultiSelect = _interopRequireDefault(require("../formatters/MultiSelect"));

var _propTypes = require("../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

MultiSelectEditor.propTypes = _propTypes.EditorProps;

function MultiSelectEditor(_ref) {
  var row = _ref.row,
      column = _ref.column,
      onRowChange = _ref.onRowChange,
      rowIdx = _ref.rowIdx,
      onClose = _ref.onClose;

  var handleClick = function handleClick(el) {
    var resolvedAnchorEl = el.getBoundingClientRect();

    var anchorEl = function anchorEl() {
      return {
        nodeType: 1,
        getBoundingClientRect: function getBoundingClientRect() {
          return resolvedAnchorEl;
        }
      };
    };

    column.setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        column: column,
        row: row,
        rowIdx: rowIdx,
        openMultiSelectMenu: anchorEl
      });
    });
    onClose();
  };

  (0, _react.useEffect)(function () {
    var el = document.getElementById("multiselect-editor");
    handleClick(el);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "multiselect-editor",
    onClick: handleClick,
    style: {
      padding: "0 8px",
      height: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_MultiSelect["default"], {
    row: row,
    column: column,
    onRowChange: onRowChange,
    isCellSelected: true,
    rowIdx: rowIdx
  }));
}